import axios from 'axios';
import config from './config';

import _ from 'lodash'



export const customAxios = axios.create(config(localStorage.getItem('token')));
customAxios.interceptors.request.use(function (config) {

    config.headers.Token = localStorage.getItem('token');
    // config.headers.Accept = 'application/json'

    return config;
}, null, { synchronous: true });
// 
customAxios.interceptors.response.use(
    response => response.data,
    error => {
        return error.response.data
    });

export default customAxios;